<div id="simple-preloader-background">
  <div class="simple-preloader-container">
    <div class="simple-preloader-text-container">
      <span class="simple-preloader-text" id="simple-preloader-text" />
    </div>
  </div>
</div>

<style>
  #simple-preloader-background {
    position: absolute;
    z-index: 1;
    height: 100%;
    width: 100%;
    background: url(../img/white.png) no-repeat;
    background-size: cover;
    opacity: 0.8;
  }
  .simple-preloader-text-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 210px;
    height: 210px;
    background: url(../img/loading.gif) no-repeat center;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  .simple-preloader-text {
    /* position: absolute; */
    /* top: 50%; */
    /* left: 50%; */
    /* transform: translate(-50%, -50%); */
    text-align: center;
    font-size: 33px;
    font-weight: 600;
    color: #008acb;
    /* test */
    font-weight: normal;
    pointer-events: none;
    vertical-align: middle;
    font-family: "Lato", sans-serif;
    /* margin-top: 0;
    margin-bottom: 1.7rem; */
  }
  /* .myClass{
  animation: hide 2s 0s linear 1;
} */
  @keyframes hide {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  /* removes tap blinking on ios devices */
  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
</style>
